export const version = 'kunde-v1.20.0-SNAPSHOT-edf5c07ab867767bdbcb4ec555a96acb59bfc60b';